import React from 'react';
import {connect} from 'react-redux';
import mapDispatch from '~/misc/mapDispatch';
import cs from 'classnames'
import css from './index.css'
import Button from '~/components/common/Button';
import {modalClose, modalChange} from '~/modules/modal/actions';
import { userDispatcher } from '~/misc/userAccount'
import * as modes from '~/modules/modal/modes';
import {push as changeURL} from 'react-router-redux';

class BidParade extends React.Component {
  constructor(props) {
    super(props)
  }
  render() {
    const {closePop, gotoVerify } = this.props;
    return (
      <div className={css.popwrap}>
        <header className={css.title}>
          <p>Profile Incomplete</p>
        </header>
        <main className={css.mainNormal}>
          Please make sure all your profile information is entered (your name, DOT, phone & email) before making an offer.
        </main>
        <footer className={css.footer}>
          <div className={css.footerRow}>
            <Button
              mods={['action']}
              className={css.button}
              onClick={()=>{
                gotoVerify();
                closePop();
              }}
            >
              Complete Now
            </Button>
          </div>
        </footer> 
      </div>
    )
  }
}

export default connect(null, mapDispatch({
  closePop: () => modalClose(modes.BID_PARADE),
  gotoVerify:(props, url) => changeURL(userDispatcher())
}))(BidParade);


// WEBPACK FOOTER //
// ./src/components/Popup/BidParade/index.js